<template>
	<div id="mb_home">

		<el-carousel height="250px">
			<el-carousel-item class="slider-item" v-for="(item,index) in sliders" :key="index">
				<el-image :src="item.img" class="slider_img" fit="cover"></el-image>
			</el-carousel-item>
		</el-carousel>
		<!-- 业务涵盖 -->
		<div class="business">业务涵盖</div>
		<div class="business-box">
			<img class="home_bg01" src="../../assets/img/home_bg01.png" alt=""/>
			<img class="home_icon01 animated pulse my_count" src="../../assets/img/home_icon01.png" alt=""/>
			<img class="home_icon02 animated pulse my_count" src="../../assets/img/home_icon02.png" alt=""/>
			<img class="home_icon03 animated pulse my_count" src="../../assets/img/home_icon03.png" alt=""/>
			<img class="home_icon04 animated pulse my_count" src="../../assets/img/home_icon04.png" alt=""/>
		</div>
		<!-- 经典案例 -->
		<div class="case">
			<div class="case-title">经典案例</div>
			<el-card
			v-waypoint="{ active: true, callback: onePoint, options: myOptions }"
			:body-style="{'padding':'0px'}"
			class="case-card"
			style="background-image: url(https://file.jxth.com.cn/group1/M02/00/25/dSm0ymDAYWeAe9vyABbQ2id7cZw247.png);">
				<div class="case-content animated" :class="{ fadeInLeftBig: oneActive}" :style="{'display': oneActive ? 'block':'none'}">
					<p class="classname">智慧交通</p>
					<p class="hover-title">井冈山G356龙市至睦村、S541龙市至茨坪段“畅、安、舒、美”科技示范路工程</p>
					<div class="bottom"></div>
					<div class="more" @click="gotoUrl('/mb_case01')">
					  <span>MORE</span>
					</div>
				</div>
			</el-card>
			<el-card
			v-waypoint="{ active: true, callback: twoPoint, options: myOptions }"
			:body-style="{'padding':'0px'}"
			class="case-card"
			style="background-image: url(https://file.jxth.com.cn/group1/M01/00/19/dSm0ymCWLR2AVHzEAAnRuO95c_I137.jpg);">
				<div class="case-content animated" :class="{ fadeInLeftBig: twoActive}" :style="{'display': twoActive ? 'block':'none'}">
					<p class="classname">智慧工地</p>
					<p class="hover-title">江西港口集团项目</p>
					<div class="bottom"></div>
					<div class="more" @click="gotoUrl('/mb_case02')">
					  <span>MORE</span>
					</div>
				</div>
			</el-card>
			<el-card
			v-waypoint="{ active: true, callback: threePoint, options: myOptions }"
			:body-style="{'padding':'0px'}"
			class="case-card"
			style="background-image: url(https://file.jxth.com.cn/group1/M00/00/19/dSm0ymCWKfiADY4ZAAQhxZVT6ZI133.jpg);">
				<div class="case-content animated" :class="{ fadeInLeftBig: threeActive}" :style="{'display': threeActive ? 'block':'none'}">
					<p class="classname">结构物健康监测</p>
					<p class="hover-title">江西省信江航电枢纽项目</p>
					<div class="bottom"></div>
					<div class="more" @click="gotoUrl('/mb_case')">
					  <span>MORE</span>
					</div>
				</div>
			</el-card>
		</div>
		<!-- 新闻资讯 -->
		<div class="news">
			<div class="news-title">新闻资讯</div>
			<el-row class="news-box" @click.native="goDetails(news)" v-for="(news,i) in newsList" :key="i">
				<el-col >
					<el-image style="width: 100%;" :src="news.cover"></el-image>
				</el-col>
				<el-col >
					<p class="news-name">{{news.title}}</p>
					<p class="news-time">{{news.createTime}}</p>
				</el-col>
			</el-row>
			<div class="news-more" @click="gotoUrl('/mb_news')">查看更多资讯>></div>
		</div>
		<!-- 联系我们 -->
		<div class="contact">
			<div class="contact-content">
				<p class="contact-us">联系我们</p>
				<div class="contact-box">
					<div class="contact-li">
						<img style="width: 150px;" src="../../assets/img/ercode.jpg" alt="" />
						<p style="color: #999999;font-size: 12px;">长按识别二维码关注官方微信公众号</p>
					</div>
				</div>
				<p class="contact-p"><i class="el-icon-message"></i> 电子邮箱：jxth@jxth.com</p>
				<p class="contact-p"><i class="el-icon-phone"></i>
					联系电话：<a href="tel:0791-86613192">0791-86613192</a>
				</p>
				<p class="contact-p">
					<i class="el-icon-location-information"></i>
					公司地址：江西省南昌经济技术开发区瑞香路900号通慧科技大厦
				</p>
				<baidu-map class="bm-view" :center="siteStartX" :zoom="13">
					<bm-marker :position="siteStartX" animation="BMAP_ANIMATION_BOUNCE">
						<bm-label
						  content="江西省南昌经济技术开发区<br/>瑞香路900号通慧科技大厦"
						  :offset="{width:20,height:0}"
						  :position="siteStartX"
						  title="江西通慧科技集团股份有限公司"
						/>
					</bm-marker>
				</baidu-map>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: 'mb_home',
	data() {
		return {
			sliders: [{
				img:'https://file.jxth.com.cn/group1/M01/00/26/dSm0ymDCzNWAA7y4AAJE65QT_5I384.jpg'
			}],
			newsList: [],
			siteStartX: { // 经纬度
			  lng: 115.810222, lat: 28.726292
			},
			intersectionOptions: {
				root: null,
				rootMargin: '0px',
				threshold: [0, 1]
			},
			myOptions: {
				root: null,
				rootMargin: '0px',
				threshold: 1
			},
			oneActive: false,
			twoActive: false,
			threeActive: false,
		}
	},
	methods:{
		gotoUrl(url){
			this.$router.push({ path:url })
		},
		goDetails(news){
			this.$router.push({ name: 'mb_newsdetails', params: { id: news.id }})
		},
		onePoint ({ going, direction }) {
			// going: in, out
			// direction: top, right, bottom, left
			if (going === this.$waypointMap.GOING_IN) {
				this.oneActive = true
			}
			if (going === this.$waypointMap.GOING_OUT) {
				this.oneActive = false
			}
		},
		twoPoint ({ going, direction }) {
			// going: in, out
			// direction: top, right, bottom, left
			if (going === this.$waypointMap.GOING_IN) {
				this.twoActive = true
			}
			if (going === this.$waypointMap.GOING_OUT) {
				this.twoActive = false
			}
		},
		threePoint ({ going, direction }) {
			// going: in, out
			// direction: top, right, bottom, left
			if (going === this.$waypointMap.GOING_IN) {
				this.threeActive = true
			}
			if (going === this.$waypointMap.GOING_OUT) {
				this.threeActive = false
			}
		},
		fourPoint ({ going, direction }) {
			// going: in, out
			// direction: top, right, bottom, left
			if (going === this.$waypointMap.GOING_IN) {

			}
			if (going === this.$waypointMap.GOING_OUT) {

			}
		}
	},
	async mounted() {
		// this.$http.post('/oa/newcms/article/getListByPage',{curPage:1,pageSize:2,category:'064dfdd0-8a17-4421-8e79-ff253eed4ebb'})
		// .then(response => {
		// 	this.newsList = response.data.result.data
		// 	// console.log(response)
		// })
		// .catch(error=> {

		// })
		const {data : { result }} = await this.$http({
			method: 'post',
			url: this.$baseURL + '/oa/newcmsArticle/getDataListByPage',
			data: {
				curPage: 1,
				pageSize: 2,
				category: '064dfdd0-8a17-4421-8e79-ff253eed4ebb'
			}
		})
		this.newsList = result.records.map(item => {
			return {
				id: item.id,
				cover: item.cover,
				title: item.title,
				createTime: item.createTime
			}
		})
	},
	computed: {

	},
}
</script>

<style lang="scss" scoped>
	.slider_img {
		height: 250px;
	}
	// 业务涵盖
	.my_count{
		animate-duration: 1s;   /* //动画持续时间 */
		animate-iteration-count: infinite;    /* //动画执行次数 */
		-webkit-animation-duration: 1s;
		-webkit-animation-iteration-count: infinite;
	}
	.business {
	   font-size: 20px;
	   width: 100%;
	   color: #222222;
	   text-align: center;
	   padding-top: 20px;
	}
	.business-box{
		height: 300px;
		position: relative;
	}
	.home_bg01{
		width: 415px;
		height: 120px;
		position: absolute;
		left: 50%;
		top: 100px;
		margin-left: -207.5px;
	}
	.home_icon01{
		width: 65px;
		height: 84.5px;
		position: absolute;
		left: 5%;
		top: 15%;
	}
	.home_icon02{
		width: 65px;
		height: 84.5px;
		position: absolute;
		right: 5%;
		top: 10%;
	}
	.home_icon03{
		width: 65px;
		height: 84.5px;
		position: absolute;
		left: 45%;
		top: 25%;
	}
	.home_icon04{
		width: 106.5px;
		height: 84.5px;
		position: absolute;
		left: 20%;
		bottom: 15%;
	}
	// 经典案例
	.case{
		background-color: #f7f8f8;
		padding: 20px;

		.case-title{
			font-size: 20px;
			color: #222222;
			margin-bottom: 15px;
			text-align: center;
		}
		.case-card{
			margin-bottom: 15px;
			height: 200px;
			background-size: 100% 100%;
			background-repeat: no-repeat;

			.case-content{
				width: 100%;
				height: 200px;
				background-color: rgba(225, 56, 52, 0.5);
				padding: 20px;
				box-sizing: border-box;
				position: relative;

				.classname{
					color: #FFFFFF;
					text-align: center;
					font-size: 13px;
					padding-top: 15px;
				}
				.hover-title {
					color: #fff;
					font-size: 14px;
					margin-top: 5px;
					margin-bottom: 10px;
					text-align: center;
				}
				.bottom {
					border-bottom: 1px solid #fff;
					width: 60px;
					margin: 0 auto;
				}
				.more {
					position: absolute;
					width: 65px;
					padding: 5px 5px;
					bottom: 20px;
					left: 50%;
					margin-left: -32.5px;
					border: 1px solid #fff;
					text-align: center;
					span {
						color: #fff;
						font-size: 14px;
					}
				}
			}
		}
	}
	//新闻资讯
	.news{
		padding: 20px;
		.news-title{
			font-size: 20px;
			color: #222222;
			margin-bottom: 15px;
			text-align: center;
		}
		.news-box{
			border-bottom: 1px solid #F8F8F8;
			margin-bottom: 10px;
			padding-bottom: 10px;

			.news-name{
				font-size: 16px;
				line-height: 1.6em;
				// padding-left: 10px;
				// height: 68px;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.news-time{
				font-size: 12px;
				text-align: right;
			}
		}
		.news-more{
			text-align: center;
			font-size: 14px;
			color: #fd5353;
		}
	}
	//联系我们
	.contact{
		background-size: 750px;
		background-image: url(../../assets/img/home_bg04.png);
		background-repeat: no-repeat;
		background-position: top center;

		.contact-content{
			padding: 20px;
			width: 100%;
			box-sizing: border-box;
			.contact-us{
				font-size: 20px;
				color: #FFFFFF;
			}
			.contact-box{
				width: 80%;
				margin: auto;
			}
			.contact-li{
				width: 100%;
				margin-top:20px;
				background-color: #FFFFFF;
				text-align: center;
				padding: 20px 0px;
			}
			.contact-p{
				margin-bottom: 10px;
				font-size: 15px;
			}
			.bm-view {
				width: 100%;
				height: 250px;
			}
		}
	}

</style>

